import {
	ExperienceName,
	useAIMateExperienceTracker,
} from '@atlassian/conversation-assistant-instrumentation';
import {
	useAssistanceService,
	type UseAssistanceServiceParams,
	useQuery,
} from '@atlassian/conversation-assistant-service';

/**
 * Fetches the agent details for the given agentId
 * @param agentId
 */
export const useAgentDetailsController = ({
	agentId,
	experienceId,
	product,
	enabled = true,
}: { agentId: string; enabled?: boolean } & UseAssistanceServiceParams) => {
	const assistanceService = useAssistanceService({ experienceId, product });
	const experience = useAIMateExperienceTracker();

	const queryResult = useQuery({
		queryKey: ['fetchAgentDetails', agentId],
		queryFn: () => {
			experience.start({
				id: ExperienceName.FETCH_AGENT_BY_AGENT_ID,
				name: ExperienceName.FETCH_AGENT_BY_AGENT_ID,
			});
			return assistanceService.getAgentDetails(agentId);
		},
		onSuccess: () => {
			experience.succeed({
				name: ExperienceName.FETCH_AGENT_BY_AGENT_ID,
			});
		},
		onError: (error) => {
			experience.fail({
				name: ExperienceName.FETCH_AGENT_BY_AGENT_ID,
				error,
			});
		},
		enabled,
	});

	return queryResult;
};

/**
 * Fetches the agent details for the given identityAccountId
 * @param identityAccountId
 */
export const useAgentDetailsByIdentityAccountId = ({
	identityAccountId,
	experienceId,
	product,
	enabled = true,
}: {
	identityAccountId: string;
	enabled?: boolean;
} & UseAssistanceServiceParams) => {
	const assistanceService = useAssistanceService({
		experienceId,
		product,
	});
	const experience = useAIMateExperienceTracker();

	const queryResult = useQuery({
		queryKey: ['fetchAgentDetails', identityAccountId],
		queryFn: () => {
			experience.start({
				id: ExperienceName.FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID,
				name: ExperienceName.FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID,
			});
			return assistanceService.getAgentDetailsByIdentityAccountId(identityAccountId);
		},
		onSuccess: () => {
			experience.succeed({
				name: ExperienceName.FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID,
			});
		},
		onError: (error) => {
			experience.fail({
				name: ExperienceName.FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID,
				error,
			});
		},
		enabled,
	});

	return queryResult;
};
